import Cookies from 'js-cookie';

// function to set tokens into the cookies declared here
export const setToken = (refresh: string, access: string) => {
  Cookies.set('refresh', refresh, { path: '/' });

  Cookies.set('access', access, { path: '/' });
};

// function to get refresh token from the cookies declared here
export const getRefreshToken = (): string | null => {
  const refreshToken = Cookies.get('refresh');

  if (!refreshToken) {
    return null;
  }

  return refreshToken;
};

// function to get access token from the cookies declared here
export const getAccessToken = (): string | null => {
  const accessToken = Cookies.get('access');

  if (!accessToken) {
    return null;
  }

  return accessToken;
};

// function to delete access & refresh tokens from the cookies declared here
export const deleteToken = (): void => {
  if (Cookies.get('access') || Cookies.get('refresh')) {
    Cookies.remove('access');
    Cookies.remove('refresh');
  }
};
